module.exports = __webpack_public_path__ + "media/Ring 6.86e846ac.mp3";